import {useMemo} from "react"
import {useIsUnitUser, useUserEmail} from "../services/auth"
import {isProdEnv} from "../utilities/environment"
import useZendesk from "./useZendesk"
import useAdaChatbot from "./useAdaChatbot"

enum ChatBotProvider {
	Zendesk = "zendesk",
	Ada = "ada",
}

const useChatbot = () => {
	const isUnitUser = useIsUnitUser()
	const isProd = isProdEnv()
	const userEmail = useUserEmail()

	const currentProvider = useMemo((): ChatBotProvider => {
		// We need Ada chatbot if sandbox or local env only. And user is a unit user or email ends with unit.co
		if (!isProd && (isUnitUser || userEmail.endsWith("unit.co"))) {
			return ChatBotProvider.Ada
		}

		// In other cases, we use Zendesk
		return ChatBotProvider.Zendesk
	}, [isUnitUser, isProd, userEmail])

	useZendesk(currentProvider === ChatBotProvider.Zendesk)
	useAdaChatbot(currentProvider === ChatBotProvider.Ada)
}

export default useChatbot
